import { http } from './HttpService.js'
import { http_app } from './HttpService.js'

export default {
	load(params = '') {
		return http.get('instalacoes' + params)
	},
	loadApp(params = '') {
		return http.get('instalacoes-app?query=' + params)
	},
	loadNovo(params = '') {
		return http.get('instalacoes/v2' + params)
	},
	loadVencimento(params = '') {
		return http.get('instalacoes/vencimento' + params)
	},
	generate(data) {
		return http.post('instalacoes/generate', data)
	},
	monitorFiscal(params = '') {
		return http.get('monitor-fiscal' + params)
	},
	monitorFiscalApp(params = '') {
		return http_app.get('instalacoes/monitorFiscal' + params)
	},
	copyApp(data) {
		return http.post('instalacoes/copy',data)
	}
}